module.exports = "/_next/static/images/fa2eccf5906ebdef13ba342adc0b68ba-hero-100m-mobile.jpg.webp";